import profilePicture from "../assets/images/profile-picture.jpg";
import { Skills } from "./Skills";

export const AboutMe = () => {
  return (
    <section className="relative w-full max-w-7xl mx-auto px-4 py-16 sm:py-24">
      <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-center lg:items-start z-10">
        
        {/* Profile Picture Section */}
        <div className="w-64 h-64 md:w-80 md:h-80 lg:w-96 lg:h-96 shrink-0 rounded-3xl md:rounded-[3rem] overflow-hidden border border-gray-800 bg-gray-900 shadow-md group">
          <img
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
            src={profilePicture}
            alt="Reece Carey Profile"
          />
        </div>

        {/* Content Section */}
        <div className="flex-1 flex flex-col items-center lg:items-start text-center lg:text-left">
          <div className="inline-block mb-4 px-4 py-1.5 rounded-full border border-gray-800 bg-gray-900/50">
            <span className="text-sm font-medium text-gray-300 uppercase tracking-wider">
              Get to know me
            </span>
          </div>

          <h1 className="text-4xl md:text-5xl font-bold text-gray-100 mb-6 tracking-tight">
            Hello, I'm Reece
          </h1>

          <p className="text-base md:text-lg text-gray-400 leading-relaxed max-w-2xl mb-8">
            A motivated and enthusiastic full stack developer with five years
            worth of experience across web and mobile platforms. I hold a First
            Class Honors (BSc) in Computer Games Programming and have
            professional experience building robust applications within the{" "}
            <strong className="text-gray-200">MERN tech stack</strong>. I am
            proficient in <strong className="text-gray-200">C languages</strong>{" "}
            and <strong className="text-gray-200">Unity</strong>. I am a
            passionate, self-motivated learner always trying to expand my skill
            set.
          </p>

          <div className="w-full pt-4">
            <Skills />
          </div>
        </div>
      </div>
    </section>
  );
};
